import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from '../app/App.scss';
import fullscreenIframeSwitcherSelector from '../../selectors/iframe/FullscreenIframeSwitcherSelector';
import FullscreenIframe from './FullscreenIframe';
import chromeAppService from '../../services/ChromeAppService';

const FullscreenIframeSwitcher = (props) => {
    const {
        additionalResources,
        currentSelectedTitle,
    } = props;

    const windowHeight = document.documentElement.clientHeight;
    const additionalResBarElement = document.getElementById('additionalResBar');
    if (!additionalResBarElement) {
        return null;
    }
    const additionalResourcesBarHeight = additionalResBarElement.offsetHeight;
    const displayHeight = currentSelectedTitle && currentSelectedTitle !== '' ? `${windowHeight - additionalResourcesBarHeight}px` : '0px';

    return (
        <div
            id="fullscreen-iframes-switcher-container"
            className={styles.fullscreenIframeContainer}
            style={{ height: displayHeight }}
        >
            {additionalResources.map((additionalResource, index) => {
                const url = chromeAppService.getChromeAppAdditionalResourceIframeUrl(additionalResource);
                let displayStyle = 'none';
                if (currentSelectedTitle === additionalResource.title) {
                    displayStyle = 'block';
                }
                const key = `additionalResource_iframe_${index}`;
                return (
                    <FullscreenIframe
                        srcURL={url}
                        displayStyle={displayStyle}
                        displayHeight={displayHeight}
                        key={key}
                    />
                );
            })}
        </div>
    );
};

FullscreenIframeSwitcher.propTypes = {
    additionalResources: PropTypes.array.isRequired,
    currentSelectedTitle: PropTypes.string.isRequired,
};

const mapStateToProps = state => fullscreenIframeSwitcherSelector.selectProps(state);
export default connect(mapStateToProps)(FullscreenIframeSwitcher);
